var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-md-4" },
        [
          _c("page-header", {
            attrs: {
              title: _vm.$t("pages.locker.my_aform.notes"),
              "use-title-as-document-title": false
            }
          }),
          _vm._v(" "),
          _c("notes")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-8" },
        [
          _c("page-header", {
            attrs: {
              title: _vm.$t("pages.locker.my_aform.my_favorite_trainings"),
              "use-title-as-document-title": false
            }
          }),
          _vm._v(" "),
          _vm.videos.length
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.videos, function(video) {
                  return _c(
                    "div",
                    { key: video.id, staticClass: "col-md-6 grid-margin" },
                    [
                      _c("gym-video-card-new", {
                        attrs: { video: video, "page-link-enabled": true }
                      })
                    ],
                    1
                  )
                }),
                0
              )
            : _c(
                "div",
                { staticClass: "alert alert-secondary border-dark shadow-sm" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("pages.locker.my_aform.no_favorites")) +
                      "\n            "
                  )
                ]
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("pagination", {
                attrs: { data: _vm.paginationData },
                on: { "pagination-change-page": _vm.getVideos }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c("page-header", {
            attrs: {
              title: _vm.$t("pages.locker.my_aform.training_stats"),
              "use-title-as-document-title": false
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-5" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("stats-infos", {
                  attrs: { user: null, dates: _vm.datesForStatsInfos }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("stats-calendar", {
                  attrs: { user: null },
                  on: { "date-change": _vm.calendarDateChanged }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }